import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=c1e51470&scoped=true"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"
import style0 from "./UserTransactions.vue?vue&type=style&index=0&id=c1e51470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e51470",
  null
  
)

export default component.exports